// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2JHwV","icon":"SortAdornment_icon__2kR8K","up":"SortAdornment_up__3eWbH","down":"SortAdornment_down__1eKOG","active":"SortAdornment_active__2f-qM"};